import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import DocumentAnalyserPage from "@/pages/DocumentAnalyserPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import ComplaintsPage from "@/pages/ComplaintsPage";
import CookiesPage from "@/pages/CookiesPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import HPClaimsPage from "@/pages/HPClaimsPage";
import CarFinanceMisSellingPage from "@/pages/CarFinanceMisSellingPage";
import FAQPage from "@/pages/FAQPage";

// Claim Pages
import GAPInsuranceClaimsPage from "@/pages/GAPInsuranceClaimsPage";
import PCPCarFinanceClaimsPage from "@/pages/PCPCarFinanceClaimsPage";

// GAP Insurance SEO Content Pages
import WhatIsGAPInsurancePage from "@/pages/gap-insurance/WhatIsGAPInsurancePage";
import HowGAPSoldWithPCPPage from "@/pages/gap-insurance/HowGAPSoldWithPCPPage";
import HowToCheckGAPMisSoldPage from "@/pages/gap-insurance/HowToCheckGAPMisSoldPage";
import FCAActionOnGAPPage from "@/pages/gap-insurance/FCAActionOnGAPPage";
import GAPInsuranceFAQPage from "@/pages/gap-insurance/GAPInsuranceFAQPage";

// PCP SEO Content Pages
import WhatIsPCPCarFinancePage from "@/pages/pcp/WhatIsPCPCarFinancePage";
import HowPCPIsMisSoldPage from "@/pages/pcp/HowPCPIsMisSoldPage";
import HowToCheckPCPMisSoldPage from "@/pages/pcp/HowToCheckPCPMisSoldPage";
import FCAMotorFinanceSchemePage from "@/pages/pcp/FCAMotorFinanceSchemePage";
import PCPClaimsFAQPage from "@/pages/pcp/PCPClaimsFAQPage";

// Partner Brand Pages
import MySolicitorPage from "@/pages/MySolicitorPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/hp-claims" element={<HPClaimsPage />} />
          <Route path="/car-finance-mis-selling" element={<CarFinanceMisSellingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/analyzer" element={<DocumentAnalyserPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/complaints" element={<ComplaintsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />

          {/* Primary Conversion Pages */}
          <Route path="/gap-insurance-claims" element={<GAPInsuranceClaimsPage />} />
          <Route path="/pcp-car-finance-claims" element={<PCPCarFinanceClaimsPage />} />

          {/* GAP Insurance SEO Content Cluster */}
          <Route path="/gap-insurance/what-is-gap-insurance" element={<WhatIsGAPInsurancePage />} />
          <Route path="/gap-insurance/how-gap-is-sold-with-pcp" element={<HowGAPSoldWithPCPPage />} />
          <Route path="/gap-insurance/how-to-check-if-gap-was-mis-sold" element={<HowToCheckGAPMisSoldPage />} />
          <Route path="/gap-insurance/fca-action-on-gap-insurance" element={<FCAActionOnGAPPage />} />
          <Route path="/gap-insurance/gap-insurance-claims-faq" element={<GAPInsuranceFAQPage />} />

          {/* PCP SEO Content Cluster */}
          <Route path="/pcp/what-is-pcp-car-finance" element={<WhatIsPCPCarFinancePage />} />
          <Route path="/pcp/how-pcp-is-mis-sold" element={<HowPCPIsMisSoldPage />} />
          <Route path="/pcp/how-to-check-if-your-pcp-was-mis-sold" element={<HowToCheckPCPMisSoldPage />} />
          <Route path="/pcp/fca-motor-finance-compensation-scheme" element={<FCAMotorFinanceSchemePage />} />
          <Route path="/pcp/pcp-claims-faq" element={<PCPClaimsFAQPage />} />

          {/* Partner Brand Pages */}
          <Route path="/mysolicitor" element={<MySolicitorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
